/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Box_Claimed_Source_EventInputs */

const en_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest Event Prize`)
};

const ar_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزة فعالية الغابة`)
};

const de_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis des Wald-Events`)
};

const es_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio del Evento del Bosque`)
};

const fr_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix de l'Évènement de la forêt`)
};

const it_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premio dell'Evento della Foresta`)
};

const ja_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森のイベント賞`)
};

const ko_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포레스트 이벤트 상`)
};

const pt_br_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêmio do Evento da Floresta`)
};

const ru_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приз лесного события`)
};

const th_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รางวัลอีเวนต์แห่งป่า`)
};

const tr_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orman Etkinliği Ödülü`)
};

const zh_cn_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森林活动奖励`)
};

const zh_tw_gift_box_claimed_source_event = /** @type {(inputs: Gift_Box_Claimed_Source_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森林活動獎勵`)
};

/**
* | output |
* | --- |
* | "Forest Event Prize" |
*
* @param {Gift_Box_Claimed_Source_EventInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const gift_box_claimed_source_event = /** @type {((inputs?: Gift_Box_Claimed_Source_EventInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Box_Claimed_Source_EventInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_box_claimed_source_event(inputs)
	if (locale === "ar") return ar_gift_box_claimed_source_event(inputs)
	if (locale === "de") return de_gift_box_claimed_source_event(inputs)
	if (locale === "es") return es_gift_box_claimed_source_event(inputs)
	if (locale === "fr") return fr_gift_box_claimed_source_event(inputs)
	if (locale === "it") return it_gift_box_claimed_source_event(inputs)
	if (locale === "ja") return ja_gift_box_claimed_source_event(inputs)
	if (locale === "ko") return ko_gift_box_claimed_source_event(inputs)
	if (locale === "pt_br") return pt_br_gift_box_claimed_source_event(inputs)
	if (locale === "ru") return ru_gift_box_claimed_source_event(inputs)
	if (locale === "th") return th_gift_box_claimed_source_event(inputs)
	if (locale === "tr") return tr_gift_box_claimed_source_event(inputs)
	if (locale === "zh_cn") return zh_cn_gift_box_claimed_source_event(inputs)
	return zh_tw_gift_box_claimed_source_event(inputs)
});